/* import __COLOCATED_TEMPLATE__ from './fin-studio-entry-point.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type FinAgentTypeService from 'embercom/services/fin-agent-type-service';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {};
}

export default class FinStudioEntryPoint extends Component<Signature> {
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare finAgentTypeService: FinAgentTypeService;
  @service declare appService: AppService;

  get finIsLive(): boolean {
    return !!this.aiAgentSetupService.isFinLive;
  }

  get finStudioRoute(): string {
    if (
      this.finAgentTypeService.currentAgentType === 'sales' &&
      this.appService.app.canUseFeature('fin-studio-for-sales')
    ) {
      return 'apps.app.automation.fin-ai-agent.sales.fin-studio';
    }
    return 'apps.app.automation.fin-ai-agent.fin-studio';
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAutomation::FinStudioEntryPoint': typeof FinStudioEntryPoint;
  }
}
